$('.gform_wrapper').addClass('content-wrap-width-only');

$('.content-wrap-item').each(function () {

    // $(this).wrap('<div class="container "><div class="row"></div></div>');

});


$('.video-modal').each(function () {
    var modal = $(this).detach();

    $('body').append(modal);
});

$('.video-modal').on('hidden.bs.modal', function (e) {
    let videoSrc = $(this).find('iframe').attr('src');
    $(this).find('iframe').attr('src', '');
    $(this).find('iframe').attr('src', videoSrc);
});


$('.advanced-caption').each(function () {

    let caption = $(this).parent().find('.wp-caption-text'),
        captionContent = caption.html();

    caption.remove();

    let imageContainer = $(this).wrap('<div class="image-with-decorative-caption"></div>').parent();

    imageContainer.append('<div class="decorative-caption">' + captionContent + '</div>');

    if($(this).hasClass('caption-green')) imageContainer.addClass('caption-green');
    if($(this).hasClass('caption-teal')) imageContainer.addClass('caption-teal');
    if($(this).hasClass('caption-blue')) imageContainer.addClass('caption-blue');
    if($(this).hasClass('caption-red')) imageContainer.addClass('caption-red');
    if($(this).hasClass('caption-black')) imageContainer.addClass('caption-black');

});

let backToTopButtonFloated = $('.back-to-top-button-floated');

function positionBackToTopButton() {
    if($(window).outerWidth() > 1600) {
        backToTopButtonFloated.css('right', $('.wrapper').offset().left + 40);
    }
}

positionBackToTopButton();

function showHideBackToTopButton() {

    if($(window).scrollTop() > 200) {
        showBackToTopButton();
    } else {
        hideBackToTopButton();
    }

}

function showBackToTopButton() {
    backToTopButtonFloated.addClass('showing');
    // setTimeout(function () {
    //     backToTopButtonFloated.addClass('showing-full');
    // }, 10);
}

function hideBackToTopButton() {
    backToTopButtonFloated.removeClass('showing');
    // setTimeout(function () {
    //     backToTopButtonFloated.removeClass('showing');
    // }, 310);
}

showHideBackToTopButton();
$(window).on('scroll', function () {
    showHideBackToTopButton();
});


$('.back-to-top-button').on('click', function () {
    $('html, body').animate({scrollTop: 0}, 500);
});


function addDividers() {
    const ul = document.getElementById('services-list-element');
    const lis = ul.getElementsByTagName('li');

    let lineBreak = false;

    for (let i = 0; i < lis.length; i++) {
        if (!lineBreak) {
            // Add a divider (comma) between items on the same line
            if (i > 0) {
                const divider = document.createElement('span');
                $(divider).html('|');
                lis[i - 1].appendChild(divider);
            }
        }

        // Check if the next item will be on a new line
        const rect1 = lis[i].getBoundingClientRect();
        if (i < lis.length - 1) {
            const rect2 = lis[i + 1].getBoundingClientRect();
            if (rect1.bottom !== rect2.bottom) {
                lineBreak = true;
            } else {
                lineBreak = false;
            }
        }
    }
}

// Call the function to add dividers
if($('#services-list-element').length) {
    addDividers();
}

let searchOpen = $('.mobile-search-open-button'),
    searchContainer = $('.search-container');

let desktopUtilityNavOpen = $('.desktop-menu-open-button'),
    desktopUtilityNav = $('.desktop-secondary-menu');

searchOpen.on('click', function (e) {
    if($(window).outerWidth() < 991) return;
    e.preventDefault();

    if(searchContainer.hasClass('search-is-open')) {
        searchContainer.removeClass('search-is-open');
    } else {
        if(desktopUtilityNav.hasClass('nav-is-open')) {
            desktopUtilityNav.removeClass('nav-is-open');
            desktopUtilityNavOpen.removeClass('menu-is-open');
        }
        searchContainer.addClass('search-is-open');
        searchContainer.find('input').focus();
    }
});

$('body').on('click', function (e) {
    if(!$(e.target).closest('.search-container').length && !$(e.target).closest('.mobile-search-open-button').length) {
        searchContainer.removeClass('search-is-open');
    }
});

desktopUtilityNavOpen.on('click', function (e) {
    desktopUtilityNavOpen.toggleClass('menu-is-open');
    e.preventDefault();

    if(desktopUtilityNav.hasClass('nav-is-open')) {
        desktopUtilityNav.removeClass('nav-is-open');
    } else {
        if(searchContainer.hasClass('search-is-open')) {
            searchContainer.removeClass('search-is-open');
        }
        desktopUtilityNav.addClass('nav-is-open');
    }
});

function positionMainDropdowns() {

    $('#main-navigation .standard_dropdown').each(function (i, e) {

        if(i !== 0) {

            let navItem = $(this).find('.standard-dropdown-toggle'),
                navMenu = $(this).find('.standard-dropdown-menu');

            let navItemWidth = navItem.outerWidth(),
                navMenuWidth = navMenu.outerWidth();

            if(navMenuWidth > navItemWidth) {
                let offset = (navMenuWidth - navItemWidth) / 2;
                navMenu.css('left', 0 - offset);
            } else {
                navMenu.css('width', navMenuWidth);
                navMenu.css('left', 0);
                navMenu.css('right', 0);
                navMenu.css('margin', '0 auto');
            }

        }

    });

}

positionMainDropdowns();
$(window).on('resize', function () {
    positionMainDropdowns();
});
